import moment from "moment";

import { DateOnly } from "@/Common/Utilities/DateAndTime/DateOnly";

Date.prototype.format = function(format: string) {
    const date: Date = this;
    if (date != null)
        return moment(this).format(format);
    else
        return null;
};

Date.prototype.toMoment = function() {
    if (this != null)
        return moment(this);
    else
        return null;
};

Date.prototype.addTicks = function(ticks: number) {
    return this.addSeconds(Math.round(ticks / 10000000));
};

Date.prototype.addSeconds = function(seconds: number) {
    return new Date(this.getTime() + seconds * 1000);
};

Date.prototype.addMinutes = function(minutes: number) {
    return this.addSeconds(minutes * 60);
};

Date.prototype.addHours = function(hours: number) {
    return this.addSeconds(hours * 3600);
};

Date.prototype.addDays = function(days: number) {
    return this.addSeconds(days * 3600 * 24);
};

Date.prototype.addYears = function(years: number) {
    return this.addSeconds(years * 365.25 * 3600 * 24);
};

/**
 * Convert the date to a structure which discards time and timezone data.
 */
Date.prototype.toDateOnly = function(this: Date): DateOnly {
    return new DateOnly(this);
};

moment.fn.setToday = function() {
    const now = moment();
    return this.set({ year: now.year(), month: now.month(), date: now.date() });
};
